// extracted by mini-css-extract-plugin
export default {"input":"UserResetPassword_input__1ZQfS","formLabel":"UserResetPassword_formLabel__xkEQB","controls":"UserResetPassword_controls__Itqhy","icon":"UserResetPassword_icon__piW6c"};